<template>
  <v-app class="alibabaPuHuiTiFontFamily">
    <!--this.$store.state.openSource为windows时不显示顶栏-->
    <top-bar v-if="this.$store.state.openSource !== 'windows' && (this.$route.path === '/home'||(this.$route.path === '/globe' && !this.$store.state.globeSceneFullScreen)
    ||this.$route.path === '/systemNoticePage'||this.$route.path === '/createArticle' ||this.$route.path === '/createVideo'||this.$route.path === '/userCenter')"
             @topBarSearchFlyToPosition="topBarSearchFlyToPosition"></top-bar>
<!--    :style="{'height':this.$route.path === '/login' ? '' : 'calc(100% - 50px)','margin-top':this.$route.path === '/login' ? '' : '50px'}"-->
    <v-main style="padding:0;">
      <router-view ref="routerView" />
    </v-main>


    <!--顶部提示Snackbar-->
    <!--类型snackbarType：success，error，info-->
    <v-snackbar
        fixed
        v-model="$store.state.snackbarShow"
        :color="$store.state.snackbarType === 'success'
        ? '#56CC5A'
        : $store.state.snackbarType === 'error'
        ? '#FF8000'
        : $store.state.snackbarType === 'info'
        ? '#0077FF'
        : $store.state.snackbarType === 'error_red'
        ? '#c24040'
        : '#a6a6a6'"
        timeout="2000"
        style="top:25px;height:50px;"
        min-width="300"
        max-height="60"
        elevation="0">
      <div style="font-size:16px;color:white;">
        <span v-show="$store.state.snackbarType === 'success'" style="margin-right:10px;" class="iconfontFamily">&#xe666;</span>
        <span v-show="$store.state.snackbarType === 'error'" style="margin-right:10px;" class="iconfontFamily">&#xe674;</span>
        <span v-show="$store.state.snackbarType === 'info'" style="margin-right:10px;font-size:20px;" class="iconfontFamily">&#xe673;</span>
        <span v-show="$store.state.snackbarType === 'error_red'" style="margin-right:10px;font-size:13px;" class="iconfontFamily">&#xe659;</span>
        {{$store.state.snackbarText}}
      </div>
    </v-snackbar>



  </v-app>
</template>

<script>
import TopBar from '/src/components/top_bar/TopBar';
export default {
  name: 'App',
  components: {
    TopBar
  },
  methods:{
    //顶bar搜索栏 飞到位置
    topBarSearchFlyToPosition(location){
      this.$refs.routerView.flyToPosition(location);
    }


  },
  beforeCreate(){
    console.log("APP：" + this.$route.path)
    this.$axios({
      method:"get",
      url:"/earthApi/main-info/getBaseStyleInfo",
      // params:{
      //   styleName:'blank'
      // }
    }).then((resultData)=>{
      resultData = resultData.data;
      if(resultData.status === 200){
        this.$utils.mapboxToken =  resultData.data['token'];

        this.$store.state.mapboxTokenIndex = true;
      }
    }).catch((err)=>{
      console.log(err);
    });
  },


};
</script>
